export default __webpack_public_path__ + "assets/images/LUXMED-loader-128.gif";